export function base64(string: string): string {
  return btoa(string);
}
